<template>
    <div style="display: inline;">
        <a-button size="small" type="danger" icon="youtube" @click="onShow">{{ text }}</a-button>

        <a-modal :destroyOnClose="true" title="查看" :width="800" :visible="visible" @ok="onOk" @cancel="onCancel">
            <video class="video" :src="videoUrl" controls autoplay @play="getdetail" />
        </a-modal>
    </div>
</template>

<script>
export default {
    props: {
        text: {
            type: String,
            default: "预览信息",
        },
        videoUrl: String,
    },
    data() {
        return {
            visible: false,
        };
    },
    methods: {
        getdetail(a) {
            this.$axios
                .post("/api/QuestionProblems/edit_preview_video_time", {
                    data: { video_time: a.target.duration, previewvideo: this.videoUrl }
                })
                .then((res) => {
                    console.info(res);
                })
                .catch((err) => {
                    console.error(err);
                });
        },
        onShow() {
            this.visible = true;
        },
        onOk() {
            this.visible = false;
        },
        onCancel() {
            this.visible = false;
        },
    },

};
</script>

<style lang="less" scoped>
.video {
    width: 100%;
}
</style>